import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import PostForm from '@app/components/apps/Post/PostForm';

export const EditPost: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Post');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/posts',
      breadcrumbName: 'Posts',
    },
    {
      path: '/edit-post',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <PostForm
        type={'edit'}
        editable={true}
        id={id}
        pageTitle={`Edit Post`}
        setCurrentBreadcrumName={setCurrentBreadcrumName}
      />
    </Row>
  );
};

export default EditPost;
